import ParentView from '@/components/ParentView'
import Layout from '@/layout'

const flowableRoutes = {
  path: '/base/system/flow',
  component: Layout,
  redirect: 'noredirect',
  funcPerms: 'system:flow',
  name: 'flowable',
  meta: {
    title: '流程管理',
    // icon: 'el-icon-s-grid',
    icon: 'index',
    affix: false,
    noCache: true
  },
  children: [
    {
      path: 'definition/list',
      component: () => import('@/views/flowable/definition/index'),
      funcPerms: 'system:flow:definition:list',
      name: 'flow-list',
      meta: {
        title: '流程定义',
        // icon: 'el-icon-menu',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'definition/model',
      component: () => import('@/views/flowable/definition/model'),
      funcPerms: 'system:flow:definition:model',
      name: 'flow-add',
      hidden: true,
      meta: {
        title: '流程设计',
        icon: 'index',
        affix: false,
        noCache: false
      }
    },
    {
      path: 'form/list',
      component: () => import('@/views/flowable/task/form/index'),
      funcPerms: 'system:flow:form:list',
      name: 'auth-roles',
      meta: {
        title: '表单配置',
        // icon: 'el-icon-menu',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'task/flowForm/index',
      component: () => import('@/views/flowable/task/flowForm/index'),
      name: 'FlowForm',
      hidden: true,
      meta: { title: '流程表单', icon: '' }

    },
    {
      path: 'expression/list',
      component: () => import('@/views/flowable/expression/index'),
      funcPerms: 'system:flow:expression:list',
      name: 'flow-expression',
      meta: {
        title: '流程表达式',
        // icon: 'el-icon-menu',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'listener/list',
      component: () => import('@/views/flowable/listener/index'),
      funcPerms: 'system:flow:listener:list',
      name: 'flow-listener',
      meta: {
        title: '流程监听',
        // icon: 'el-icon-menu',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'group/list',
      component: () => import('@/views/flowable/group/index'),
      funcPerms: 'system:flow:group',
      name: 'flow-group',
      meta: {
        title: '审批组',
        // icon: 'el-icon-user',
        icon: 'index',
        affix: false,
        noCache: true
      }
    }
  ]
}

export default flowableRoutes
